import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/sessions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/sessions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/sessions/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/sessions/${id}`)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  update,
  destroy
}
